<form [formGroup]="personalInfoForm" (ngSubmit)="updatePersonalInfo()">
  <div class="grid w-full">
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="firstName">First Name *</label>
      <input type="text" class="input_style" formControlName="firstName"
      [class.error]="personalInfoForm.get('firstName')?.invalid && personalInfoForm.get('firstName')?.touched"
      placeholder="Enter your first name"/>
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('firstName')?.invalid && personalInfoForm.get('firstName')?.touched">
        First name is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="lastName">Last Name</label>
      <input type="text" class="input_style" formControlName="lastName" placeholder="Enter your last name">
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="gender">Gender *</label>
      <p-dropdown formControlName="gender" [options]="genders" optionLabel="name" optionValue="value"
        placeholder="Select Gender" appendTo="body" class="w-full" styleClass="select_type"
        [class.error]="personalInfoForm.get('gender')?.invalid && personalInfoForm.get('gender')?.touched"/>
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('gender')?.invalid && personalInfoForm.get('gender')?.touched">
        Gender is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="dateOfBirth">Date of Birth *</label>
      <p-calendar formControlName="dateOfBirth" appendTo="body" [iconDisplay]="'input'" [showIcon]="true"
        inputId="dateOfBirth" styleClass="input_cal"
        [class.error]="personalInfoForm.get('dateOfBirth')?.invalid && personalInfoForm.get('dateOfBirth')?.touched"
        placeholder="Select your date of birth" />
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('dateOfBirth')?.invalid && personalInfoForm.get('dateOfBirth')?.touched">
        Date of birth is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="location">Location *</label>
      <p-autoComplete formControlName="location" [suggestions]="suggestions"
        (completeMethod)="searchLocation($event)" optionLabel="description" [minLength]="3" placeholder="Enter your location"
        (onSelect)="onLocationSelect($event)"
        styleClass="w-full" inputStyleClass="w-full input_style" [panelStyle]="{'width':'100%', 'max-width': '100%'}"
        [class.error]="personalInfoForm.get('location')?.invalid && personalInfoForm.get('location')?.touched">
        <ng-template let-prediction pTemplate="item">
          <div class="white-space-normal" style="word-wrap: break-word;">
            {{prediction.description}}
          </div>
        </ng-template>
      </p-autoComplete>
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('location')?.invalid && personalInfoForm.get('location')?.touched">
        Location is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="intendedCountries">Intended Countries *</label>
      <p-multiSelect [options]="countries" styleClass="select_type full-multiselect w-full" formControlName="intendedCountries" optionLabel="label" optionValue="value"
        placeholder="Select Countries" appendTo="body" class="w-full"
        [class.error]="personalInfoForm.get('intendedCountries')?.invalid && personalInfoForm.get('intendedCountries')?.touched">
        <ng-template let-option pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <img [src]="option.icon" alt=" " width="20" height="20" />
                  <span>{{ option.label }}</span>
                </div>
          </ng-template>
      </p-multiSelect>
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('intendedCountries')?.invalid && personalInfoForm.get('intendedCountries')?.touched">
        At least one country is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="intendedLevel">Intended Level *</label>
      <p-dropdown formControlName="intendedLevel" [options]="courseLevels" optionLabel="name" optionValue="key"
        placeholder="Select Level" appendTo="body" class="w-full" styleClass="select_type"
        [class.error]="personalInfoForm.get('intendedLevel')?.invalid && personalInfoForm.get('intendedLevel')?.touched" />
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('intendedLevel')?.invalid && personalInfoForm.get('intendedLevel')?.touched">
        Intended level is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="collegeStartTiming">When do you plan on starting college? *</label>
      <p-dropdown formControlName="collegeStartTiming" [options]="collegeStartTimings" optionLabel="name"
        optionValue="key" placeholder="Select" appendTo="body" class="w-full" styleClass="select_type"
        [class.error]="personalInfoForm.get('collegeStartTiming')?.invalid && personalInfoForm.get('collegeStartTiming')?.touched" />
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('collegeStartTiming')?.invalid && personalInfoForm.get('collegeStartTiming')?.touched">
        Start time is required
      </small>
    </div>
    <div class="col-12 flex flex-column gap-1 md:col-6">
      <label for="journeyStatus">Choose where you are in your journey? *</label>
      <p-dropdown formControlName="journeyStatus" [options]="journeryStatus" optionLabel="name" optionValue="key"
        placeholder="Select" appendTo="body" class="w-full" styleClass="select_type"
        [class.error]="personalInfoForm.get('journeyStatus')?.invalid && personalInfoForm.get('journeyStatus')?.touched">
        <ng-template let-journeyStatus pTemplate="item">
            <div class="flex align-items-center gap-2">
                <img [src]="journeyStatus.icon" alt="{{ journeyStatus.label }}" width="20" height="20" />
                <span>{{ journeyStatus.name }}</span>
            </div>
        </ng-template>
      </p-dropdown>
      <small class="text-red-500"
        *ngIf="personalInfoForm.get('journeyStatus')?.invalid && personalInfoForm.get('journeyStatus')?.touched">
        Journey status is required
      </small>
    </div>
  </div>

  <div class="w-full flex align-items-center justify-content-end gap-3 pt-4">
    <p-button label="Reset Information" styleClass="reset_inf" (onClick)="resetPersonalInfo()" />
    <p-button label="Update Information" styleClass="update_inf" [loading]="loading"
      (onClick)="updatePersonalInfo()" />
  </div>
</form>
